import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/ViewerManagement';

const getListEventOfViewerReducer = handleActions({
    [Actions.GetListEventOfViewerRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListEventOfViewerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListEventOfViewerRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListEventOfViewer]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateStatusViewerReducer = handleActions({
    [Actions.UpdateStatusViewerRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.UpdateStatusViewerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.UpdateStatusViewerRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListEventOfViewer]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const getCsvViewerReducer = handleActions({
    [Actions.GetCsvViewerRequested]: (state) => ({
        ...state,
        isFetching: true,
        errors: {},
        success: false,
    }),
    [Actions.GetCsvViewerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetCsvViewerReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.GetCsvViewerClear]: () => ({
        isFetching: false,
        data: '',
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: '',
    errors: {},
    success: false,
});

export default combineReducers({
    get: getListEventOfViewerReducer,
    update: updateStatusViewerReducer,
    getCsvViewer: getCsvViewerReducer,
});
